"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
/**
 * Patient Experience API
 * patient-experience-api
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
__exportStar(require("./apis/default-api"), exports);
__exportStar(require("./apis/app-api"), exports);
__exportStar(require("./apis/care-plan-api"), exports);
__exportStar(require("./apis/clinical-alerts-api"), exports);
__exportStar(require("./apis/eligibles-api"), exports);
__exportStar(require("./apis/medication-api"), exports);
__exportStar(require("./apis/mobile-api"), exports);
__exportStar(require("./apis/partner-api"), exports);
__exportStar(require("./apis/patients-api"), exports);
